import React, { useState } from "react"
import "../../../../assets/css/Finance/Style/PayrollManagement/payroll_management.css"
import { Container, Table, Row, Col, Card, CardBody, Form } from "reactstrap"
// import Breadcrumbs from "../../../components/Common/Breadcrumb"
import Breadcrumbs from "../../../../components/Common/Breadcrumb"
import classNames from "classnames" // Install this library for class name management
import { right } from "@popperjs/core"
import Select from "react-select"

import PunchingDetails from "../../../../assets/images/Payroll management/PunchDetails.jpg"
import PunchPreview from "../../../../assets/images/Payroll management/PunchPreview.jpg"
import LeaveDetails from "../../../../assets/images/Payroll management/LeaveDetails.jpg"
import Confirm from "../../../../assets/images/Payroll management/Confirm.jpg"
import PunchPreview1 from "../../../../assets/images/PunchPreview.jpg"
import ConfirmDetails from "../../../../assets/images/ConfirmDetails.jpg"

import { Label } from "reactstrap"
// Step Navigation Step Component
const StepNavigationStep = ({ step, currentStep }) => {
  const classes = classNames({
    active: step.id === currentStep,
    complete: currentStep > step.id,
  })

  return (
    <li className={classes}>
      <div className="step">
        <i className={step.icon_class}></i>
      </div>
      <div className="caption hidden-xs hidden-sm">
        Step <span>{step.id}</span>: <span>{step.title}</span>
      </div>
    </li>
  )
}

// Step Navigation Component
const StepNavigation = ({ steps, currentStep }) => {
  return (
    <ol className="step-indicator">
      {steps.map(step => (
        <StepNavigationStep
          key={step.id}
          step={step}
          currentStep={currentStep}
        />
      ))}
    </ol>
  )
}

// Step Component
const Step = ({ step, stepCount, currentStep, onStepChange }) => {
  const isActive = step.id === currentStep
  const isFirstStep = currentStep === 1
  const isLastStep = currentStep === stepCount

  const stepWrapperClass = classNames({
    "step-wrapper": true,
    active: isActive,
  })

  const nextStep = () => {
    if (!isLastStep) onStepChange(currentStep + 1)
  }

  const prevStep = () => {
    if (!isFirstStep) onStepChange(currentStep - 1)
  }

  return (
    <div className={`${stepWrapperClass} text-end pe-4`}>
      <button
        type="button"
        className="btn btn-primary me-2 px-4"
        onClick={prevStep}
        disabled={isFirstStep}
      >
        Back
      </button>
      <button
        type="button"
        className="btn btn-primary px-4"
        onClick={nextStep}
        disabled={isLastStep}
      >
        Next
      </button>
    </div>
  )
}

// Main App Component
const PunchDetails = () => {
  const [currentStep, setCurrentStep] = useState(1)
  const [handleEdit, setHandleEdit] = useState(true)
  const [formPopup, setFormPopup] = useState(false)

  const steps = [
    { id: 1, title: "Punching Details", icon_class: "fa  fa-id-card" },
    { id: 2, title: "Leave Details", icon_class: "fa  fa-calendar-day" },
    { id: 3, title: "Punching Preview", icon_class: "fa fa-id-card" },
    // { id: 4, title: "Confirm Details", icon_class: "fa fa-square-check" },
    // { id: 4, title: "Confirm Details", icon_class: "bi bi-check-circle-fill" },
  ]

  const stepChanged = step => {
    setCurrentStep(step)
  }

  const leaves = [
    { label: "India", value: "1" },
    { label: "UK", value: "2" },
  ]
  const month_option = [
    { label: "January", value: "January" },
    { label: "February", value: "February" },
    { label: "March", value: "March" },
    { label: "April", value: "April" },
    { label: "May", value: "May" },
    { label: "June", value: "June" },
    { label: "July", value: "July" },
    { label: "August", value: "August" },
    { label: "September", value: "September" },
    { label: "October", value: "October" },
    { label: "November", value: "November" },
    { label: "December", value: "December" },
  ]

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"Dashboard"} breadcrumbItem={"Punch Details"} />
          <Row></Row>
          <Row>
            <Col lg={12} className="p-0">
              <Card>
                <CardBody>
                  <form action="">
                    <div className="container-fluid">
                      <StepNavigation steps={steps} currentStep={currentStep} />

                      {/* <h1>Step 1</h1> */}
                      <div
                        style={{
                          display: currentStep === 1 ? "block" : "none",
                        }}
                      >
                        <Container fluid>
                          <Row className="bg-white py-4 shadow mb-3">
                            <div className="col-md-4">
                              <img
                                src={PunchingDetails}
                                className="img-fluid"
                              ></img>
                            </div>
                            <div className="mb-2 col-md-8 p-3 mb-3">
                              <div className="d-flex justify-space-between align-items-center">
                                <div>
                                  <h3 className="my-3">Punching Details</h3>
                                </div>

                                <button
                                  onClick={() => setFormPopup(!formPopup)}
                                  className="btn btn-outline-secondary  me-3"
                                >
                                  <i className="fas fa-filter"></i>
                                </button>
                              </div>
                              <div className="table-responsive punch-table">
                                <Table className="table table-bordered mb-0">
                                  <thead
                                    className="bg-white"
                                    style={{ position: "sticky", top: 0 }}
                                  >
                                    <tr>
                                      <th
                                        style={{ width: "5%" }}
                                        className="text-center punch-header"
                                      >
                                        ID
                                      </th>
                                      <th
                                        style={{ width: "10%" }}
                                        className="text-center punch-header"
                                      >
                                        Date
                                      </th>
                                      <th
                                        style={{ width: "10%" }}
                                        className="text-center punch-header"
                                      >
                                        Punch In
                                      </th>
                                      <th
                                        style={{ width: "10%" }}
                                        className="text-center punch-header"
                                      >
                                        Punch Out
                                      </th>
                                      <th
                                        style={{ width: "10%" }}
                                        className="text-center punch-header"
                                      >
                                        Work Time
                                      </th>
                                      <th
                                        style={{ width: "10%" }}
                                        className="text-center punch-header"
                                      >
                                        Punctual Deduction
                                      </th>
                                      <th style={{ width: "15%" }}>Status</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <th scope="row" className="text-center">
                                        1
                                      </th>
                                      <td className="text-center">
                                        14/08/2024
                                      </td>
                                      <td className="text-center">6.30</td>
                                      <td className="text-center">9.30</td>
                                      <td className="text-center">8 hrs</td>
                                      <td className="text-center">-</td>
                                      <td>-</td>
                                    </tr>
                                    <tr>
                                      <th scope="row" className="text-center">
                                        2
                                      </th>
                                      <td className="text-center">
                                        16/08/2024
                                      </td>
                                      <td className="text-center">9.31</td>
                                      <td className="text-center">6.30</td>
                                      <td className="text-center">8 hrs</td>
                                      <td className="text-center">1</td>
                                      <td>-</td>
                                    </tr>
                                    <tr>
                                      <th scope="row" className="text-center">
                                        3
                                      </th>
                                      <td className="text-center">
                                        21/08/2024
                                      </td>
                                      <td className="text-center">9.34</td>
                                      <td className="text-center">6.30</td>
                                      <td className="text-center">8 hrs</td>
                                      <td className="text-center">1</td>
                                      <td>-</td>
                                    </tr>
                                    <tr>
                                      <th scope="row" className="text-center">
                                        4
                                      </th>
                                      <td className="text-center">
                                        22/08/2024
                                      </td>
                                      <td className="text-center">9.31</td>
                                      <td className="text-center">6.30</td>
                                      <td className="text-center">8 hrs</td>
                                      <td className="text-center">1</td>
                                      <td>-</td>
                                    </tr>
                                    <tr>
                                      <th scope="row" className="text-center">
                                        5
                                      </th>
                                      <td className="text-center">
                                        22/08/2024
                                      </td>
                                      <td className="text-center">9.31</td>
                                      <td className="text-center">6.30</td>
                                      <td className="text-center">8 hrs</td>
                                      <td className="text-center">1</td>
                                      <td>-</td>
                                    </tr>
                                    <tr>
                                      <th scope="row" className="text-center">
                                        6
                                      </th>
                                      <td className="text-center">
                                        22/08/2024
                                      </td>
                                      <td className="text-center">9.31</td>
                                      <td className="text-center">6.30</td>
                                      <td className="text-center">8 hrs</td>
                                      <td className="text-center">1</td>
                                      <td>-</td>
                                    </tr>
                                    <tr>
                                      <th scope="row" className="text-center">
                                        7
                                      </th>
                                      <td className="text-center">
                                        22/08/2024
                                      </td>
                                      <td className="text-center">9.31</td>
                                      <td className="text-center">6.30</td>
                                      <td className="text-center">8 hrs</td>
                                      <td className="text-center">1</td>
                                      <td>-</td>
                                    </tr>
                                    <tr>
                                      <th scope="row" className="text-center">
                                        8
                                      </th>
                                      <td className="text-center">
                                        22/08/2024
                                      </td>
                                      <td className="text-center">9.31</td>
                                      <td className="text-center">6.30</td>
                                      <td className="text-center">8 hrs</td>
                                      <td className="text-center">1</td>
                                      <td>-</td>
                                    </tr>
                                    <tr>
                                      <th scope="row" className="text-center">
                                        9
                                      </th>
                                      <td className="text-center">
                                        22/08/2024
                                      </td>
                                      <td className="text-center">9.31</td>
                                      <td className="text-center">6.30</td>
                                      <td className="text-center">8 hrs</td>
                                      <td className="text-center">1</td>
                                      <td>-</td>
                                    </tr>
                                    <tr>
                                      <th scope="row" className="text-center">
                                        10
                                      </th>
                                      <td className="text-center">
                                        22/08/2024
                                      </td>
                                      <td className="text-center">9.31</td>
                                      <td className="text-center">6.30</td>
                                      <td className="text-center">8 hrs</td>
                                      <td className="text-center">1</td>
                                      <td>-</td>
                                    </tr>
                                    <tr>
                                      <th scope="row" className="text-center">
                                        11
                                      </th>
                                      <td className="text-center">
                                        22/08/2024
                                      </td>
                                      <td className="text-center">9.31</td>
                                      <td className="text-center">6.30</td>
                                      <td className="text-center">8 hrs</td>
                                      <td className="text-center">1</td>
                                      <td>-</td>
                                    </tr>
                                  </tbody>
                                </Table>
                              </div>
                              {/* </div> */}
                            </div>
                          </Row>
                        </Container>
                        {formPopup ? (
                          <div id="punch-filter">
                            <div className="popup-form p-4">
                              <Form
                                onSubmit={e => 
                                  e.preventDefault()
                                }
                              >
                                <Row className="align-items-end">
                                  <Row
                                    className="d-flex pe-0 me-0"
                                    style={{ width: "100%" }}
                                  >
                                    <div className="col-md-3 mt-2">
                                      <label htmlFor="">Month</label>
                                      <Select
                                        placeholder="Select Month"
                                        className="basic-multi-select"
                                        classNamePrefix=" select"
                                        // styles={colourStyles}
                                        options={month_option}
                                        closeMenuOnSelect={false}
                                      />
                                    </div>

                                    <div className="col-md-3 mt-2">
                                      <label htmlFor="">
                                        Save and Clear Filters
                                      </label>
                                      <div>
                                        <a
                                          className="btn  btn-primary mr-10"
                                          style={{
                                            fontSize: "11px",
                                            backgroundColor: "#93a6ff",
                                            borderColor: "#93a6ff",
                                            color: "black",
                                          }}
                                        >
                                          Save Filters
                                        </a>
                                        <a
                                          className="btn  btn-danger"
                                          style={{
                                            fontSize: "11px",
                                            backgroundColor: "#fed36d",
                                            borderColor: "#fed36d",
                                            color: "black",
                                          }}
                                        >
                                          Clear Filters
                                        </a>
                                      </div>
                                    </div>
                                    <div className="d-flex col-md-2 mb-1 align-items-end justify-content-end">
                                      <div className="mr-10">
                                        <button className="btn  btn-purple">
                                          <i className="fas fa-filter search-icon me-1 icon-center"></i>{" "}
                                          Filter
                                        </button>
                                      </div>
                                      <div className="">
                                        <a
                                          className="btn  btn-red"
                                          onClick={() => setFormPopup(false)}
                                        >
                                          <i className="dripicons-cross me-1 icon-center"></i>{" "}
                                          Close
                                        </a>
                                      </div>
                                    </div>
                                  </Row>
                                </Row>
                              </Form>
                              <i className="bi bi-triangle-fill pop-icon"></i>
                            </div>
                          </div>
                        ) : null}
                      </div>

                      {/* <h1>Step 2</h1> */}
                      <div
                        style={{
                          display: currentStep === 2 ? "block" : "none",
                        }}
                      >
                        {/* <h1>Step 2</h1> */}
                        <Container fluid>
                          <Row className="bg-white py-4 shadow mb-3">
                            <div className="mb-2 container d-flex justify-content-center w-100">
                              <div className="d-flex w-100">
                                <div className="col-md-12 d-flex justify-content-start align-items-start">
                                  <div className="col-md-5">
                                    <img
                                      src={LeaveDetails}
                                      className="img-fluid"
                                      style={{ width: "80%" }}
                                    ></img>
                                  </div>
                                  <div
                                    className="table-responsive col-md-6 punch-table"
                                    style={{ width: "100%" }}
                                  >
                                    <Table
                                      // id="myTable"
                                      className="table table-bordered mb-0 text-start"
                                      style={{ width: 600 }}
                                    >
                                      <thead
                                        className="bg-white"
                                        style={{ position: "sticky", top: 0 }}
                                      >
                                        <tr>
                                          <th
                                            style={{
                                              width: "40%",
                                              textAlign: "center",
                                            }}
                                            className="punch-header"
                                          >
                                            Date
                                          </th>
                                          <th
                                            scope="col"
                                            style={{ textAlign: "center" }}
                                            className="punch-header"
                                          >
                                            Status
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <td style={{ textAlign: "center" }}>
                                            03-06-2024
                                          </td>
                                          <td>
                                            <select
                                              className="form-control leave_un_status"
                                              data-punchid={16}
                                              data-date="2024-06-03"
                                              data-date_show="03-06-2024"
                                            >
                                              <option
                                                value=""
                                                selected=""
                                                disabled=""
                                              >
                                                ---Select Leave Status---
                                              </option>
                                              <option value={11}>
                                                Approved Sick Leave
                                              </option>
                                              <option value={12}>
                                                Unapproved Sick Leave
                                              </option>
                                              <option value={21}>
                                                Approved Earned Leave
                                              </option>
                                              <option value={22}>
                                                Unapproved Earned Leave
                                              </option>
                                              <option value={31}>
                                                Approved Casual Leave
                                              </option>
                                              <option value={32}>
                                                Unapproved Casual Leave
                                              </option>
                                              <option value={33}>
                                                Uninformed Leave
                                              </option>
                                            </select>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style={{ textAlign: "center" }}>
                                            04-06-2024
                                          </td>
                                          <td>
                                            <select
                                              className="form-control leave_un_status"
                                              data-punchid={16}
                                              data-date="2024-06-04"
                                              data-date_show="04-06-2024"
                                            >
                                              <option
                                                value=""
                                                selected=""
                                                disabled=""
                                              >
                                                ---Select Leave Status---
                                              </option>
                                              <option value={11}>
                                                Approved Sick Leave
                                              </option>
                                              <option value={12}>
                                                Unapproved Sick Leave
                                              </option>
                                              <option value={21}>
                                                Approved Earned Leave
                                              </option>
                                              <option value={22}>
                                                Unapproved Earned Leave
                                              </option>
                                              <option value={31}>
                                                Approved Casual Leave
                                              </option>
                                              <option value={32}>
                                                Unapproved Casual Leave
                                              </option>
                                              <option value={33}>
                                                Uninformed Leave
                                              </option>
                                            </select>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style={{ textAlign: "center" }}>
                                            05-06-2024
                                          </td>
                                          <td>
                                            <select
                                              className="form-control leave_un_status"
                                              data-punchid={16}
                                              data-date="2024-06-05"
                                              data-date_show="05-06-2024"
                                            >
                                              <option
                                                value=""
                                                selected=""
                                                disabled=""
                                              >
                                                ---Select Leave Status---
                                              </option>
                                              <option value={11}>
                                                Approved Sick Leave
                                              </option>
                                              <option value={12}>
                                                Unapproved Sick Leave
                                              </option>
                                              <option value={21}>
                                                Approved Earned Leave
                                              </option>
                                              <option value={22}>
                                                Unapproved Earned Leave
                                              </option>
                                              <option value={31}>
                                                Approved Casual Leave
                                              </option>
                                              <option value={32}>
                                                Unapproved Casual Leave
                                              </option>
                                              <option value={33}>
                                                Uninformed Leave
                                              </option>
                                            </select>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style={{ textAlign: "center" }}>
                                            06-06-2024
                                          </td>
                                          <td>
                                            <select
                                              className="form-control leave_un_status"
                                              data-punchid={16}
                                              data-date="2024-06-06"
                                              data-date_show="06-06-2024"
                                            >
                                              <option
                                                value=""
                                                selected=""
                                                disabled=""
                                              >
                                                ---Select Leave Status---
                                              </option>
                                              <option value={11}>
                                                Approved Sick Leave
                                              </option>
                                              <option value={12}>
                                                Unapproved Sick Leave
                                              </option>
                                              <option value={21}>
                                                Approved Earned Leave
                                              </option>
                                              <option value={22}>
                                                Unapproved Earned Leave
                                              </option>
                                              <option value={31}>
                                                Approved Casual Leave
                                              </option>
                                              <option value={32}>
                                                Unapproved Casual Leave
                                              </option>
                                              <option value={33}>
                                                Uninformed Leave
                                              </option>
                                            </select>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style={{ textAlign: "center" }}>
                                            07-06-2024
                                          </td>
                                          <td>
                                            <select
                                              className="form-control leave_un_status"
                                              data-punchid={16}
                                              data-date="2024-06-07"
                                              data-date_show="07-06-2024"
                                            >
                                              <option
                                                value=""
                                                selected=""
                                                disabled=""
                                              >
                                                ---Select Leave Status---
                                              </option>
                                              <option value={11}>
                                                Approved Sick Leave
                                              </option>
                                              <option value={12}>
                                                Unapproved Sick Leave
                                              </option>
                                              <option value={21}>
                                                Approved Earned Leave
                                              </option>
                                              <option value={22}>
                                                Unapproved Earned Leave
                                              </option>
                                              <option value={31}>
                                                Approved Casual Leave
                                              </option>
                                              <option value={32}>
                                                Unapproved Casual Leave
                                              </option>
                                              <option value={33}>
                                                Uninformed Leave
                                              </option>
                                            </select>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style={{ textAlign: "center" }}>
                                            07-06-2024
                                          </td>
                                          <td>
                                            <select
                                              className="form-control leave_un_status"
                                              data-punchid={16}
                                              data-date="2024-06-07"
                                              data-date_show="07-06-2024"
                                            >
                                              <option
                                                value=""
                                                selected=""
                                                disabled=""
                                              >
                                                ---Select Leave Status---
                                              </option>
                                              <option value={11}>
                                                Approved Sick Leave
                                              </option>
                                              <option value={12}>
                                                Unapproved Sick Leave
                                              </option>
                                              <option value={21}>
                                                Approved Earned Leave
                                              </option>
                                              <option value={22}>
                                                Unapproved Earned Leave
                                              </option>
                                              <option value={31}>
                                                Approved Casual Leave
                                              </option>
                                              <option value={32}>
                                                Unapproved Casual Leave
                                              </option>
                                              <option value={33}>
                                                Uninformed Leave
                                              </option>
                                            </select>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td style={{ textAlign: "center" }}>
                                            07-06-2024
                                          </td>
                                          <td>
                                            <select
                                              className="form-control leave_un_status"
                                              data-punchid={16}
                                              data-date="2024-06-07"
                                              data-date_show="07-06-2024"
                                            >
                                              <option
                                                value=""
                                                selected=""
                                                disabled=""
                                              >
                                                ---Select Leave Status---
                                              </option>
                                              <option value={11}>
                                                Approved Sick Leave
                                              </option>
                                              <option value={12}>
                                                Unapproved Sick Leave
                                              </option>
                                              <option value={21}>
                                                Approved Earned Leave
                                              </option>
                                              <option value={22}>
                                                Unapproved Earned Leave
                                              </option>
                                              <option value={31}>
                                                Approved Casual Leave
                                              </option>
                                              <option value={32}>
                                                Unapproved Casual Leave
                                              </option>
                                              <option value={33}>
                                                Uninformed Leave
                                              </option>
                                            </select>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style={{ textAlign: "center" }}>
                                            07-06-2024
                                          </td>
                                          <td>
                                            <select
                                              className="form-control leave_un_status"
                                              data-punchid={16}
                                              data-date="2024-06-07"
                                              data-date_show="07-06-2024"
                                            >
                                              <option
                                                value=""
                                                selected=""
                                                disabled=""
                                              >
                                                ---Select Leave Status---
                                              </option>
                                              <option value={11}>
                                                Approved Sick Leave
                                              </option>
                                              <option value={12}>
                                                Unapproved Sick Leave
                                              </option>
                                              <option value={21}>
                                                Approved Earned Leave
                                              </option>
                                              <option value={22}>
                                                Unapproved Earned Leave
                                              </option>
                                              <option value={31}>
                                                Approved Casual Leave
                                              </option>
                                              <option value={32}>
                                                Unapproved Casual Leave
                                              </option>
                                              <option value={33}>
                                                Uninformed Leave
                                              </option>
                                            </select>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td style={{ textAlign: "center" }}>
                                            07-06-2024
                                          </td>
                                          <td>
                                            <select
                                              className="form-control leave_un_status"
                                              data-punchid={16}
                                              data-date="2024-06-07"
                                              data-date_show="07-06-2024"
                                            >
                                              <option
                                                value=""
                                                selected=""
                                                disabled=""
                                              >
                                                ---Select Leave Status---
                                              </option>
                                              <option value={11}>
                                                Approved Sick Leave
                                              </option>
                                              <option value={12}>
                                                Unapproved Sick Leave
                                              </option>
                                              <option value={21}>
                                                Approved Earned Leave
                                              </option>
                                              <option value={22}>
                                                Unapproved Earned Leave
                                              </option>
                                              <option value={31}>
                                                Approved Casual Leave
                                              </option>
                                              <option value={32}>
                                                Unapproved Casual Leave
                                              </option>
                                              <option value={33}>
                                                Uninformed Leave
                                              </option>
                                            </select>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td style={{ textAlign: "center" }}>
                                            07-06-2024
                                          </td>
                                          <td>
                                            <select
                                              className="form-control leave_un_status"
                                              data-punchid={16}
                                              data-date="2024-06-07"
                                              data-date_show="07-06-2024"
                                            >
                                              <option
                                                value=""
                                                selected=""
                                                disabled=""
                                              >
                                                ---Select Leave Status---
                                              </option>
                                              <option value={11}>
                                                Approved Sick Leave
                                              </option>
                                              <option value={12}>
                                                Unapproved Sick Leave
                                              </option>
                                              <option value={21}>
                                                Approved Earned Leave
                                              </option>
                                              <option value={22}>
                                                Unapproved Earned Leave
                                              </option>
                                              <option value={31}>
                                                Approved Casual Leave
                                              </option>
                                              <option value={32}>
                                                Unapproved Casual Leave
                                              </option>
                                              <option value={33}>
                                                Uninformed Leave
                                              </option>
                                            </select>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style={{ textAlign: "center" }}>
                                            07-06-2024
                                          </td>
                                          <td>
                                            <select
                                              className="form-control leave_un_status"
                                              data-punchid={16}
                                              data-date="2024-06-07"
                                              data-date_show="07-06-2024"
                                            >
                                              <option
                                                value=""
                                                selected=""
                                                disabled=""
                                              >
                                                ---Select Leave Status---
                                              </option>
                                              <option value={11}>
                                                Approved Sick Leave
                                              </option>
                                              <option value={12}>
                                                Unapproved Sick Leave
                                              </option>
                                              <option value={21}>
                                                Approved Earned Leave
                                              </option>
                                              <option value={22}>
                                                Unapproved Earned Leave
                                              </option>
                                              <option value={31}>
                                                Approved Casual Leave
                                              </option>
                                              <option value={32}>
                                                Unapproved Casual Leave
                                              </option>
                                              <option value={33}>
                                                Uninformed Leave
                                              </option>
                                            </select>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </Table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Row>
                        </Container>
                      </div>

                      {/* <h1>Step 3</h1> */}
                      <div
                        style={{
                          display: currentStep === 3 ? "block" : "none",
                        }}
                      >
                        <Container fluid>
                          <Row className="bg-white py-4 shadow mb-3">
                            <div className="col-md-4">
                              <img
                                src={PunchPreview}
                                className="img-fluid"
                                style={{ width: "90%" }}
                              ></img>
                            </div>
                            <div className="mb-2 col-md-8 p-3 mb-3">
                            <div className="d-flex justify-space-between align-items-center">
                                <div>
                                  <h3 className="my-3">Punching Preview</h3>
                                </div>

                                <button
                                  onClick={() => setFormPopup(!formPopup)}
                                  className="btn btn-outline-secondary  me-3"
                                >
                                  <i className="fas fa-filter"></i>
                                </button>
                              </div>
                              <div className="table-responsive punch-table">
                                <Table className="table table-bordered mb-0">
                                  <thead
                                    className="bg-white"
                                    style={{ position: "sticky", top: 0 }}
                                  >
                                    <tr>
                                      <th
                                        style={{ width: "5%" }}
                                        className="text-center punch-header"
                                      >
                                        ID
                                      </th>
                                      <th
                                        style={{ width: "10%" }}
                                        className="text-center punch-header"
                                      >
                                        Date
                                      </th>
                                      <th
                                        style={{ width: "10%" }}
                                        className="text-center punch-header"
                                      >
                                        Punch In
                                      </th>
                                      <th
                                        style={{ width: "10%" }}
                                        className="text-center punch-header"
                                      >
                                        Punch Out
                                      </th>
                                      <th
                                        style={{ width: "10%" }}
                                        className="text-center punch-header"
                                      >
                                        Work Time
                                      </th>
                                      <th
                                        style={{ width: "10%" }}
                                        className="text-center punch-header"
                                      >
                                        Punctual Deduction
                                      </th>
                                      <th style={{ width: "15%" }}>Status</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <th scope="row" className="text-center">
                                        1
                                      </th>
                                      <td className="text-center">
                                        14/08/2024
                                      </td>
                                      <td className="text-center">6.30</td>
                                      <td className="text-center">9.30</td>
                                      <td className="text-center">8 hrs</td>
                                      <td className="text-center">-</td>
                                      <td>-</td>
                                    </tr>
                                    <tr>
                                      <th scope="row" className="text-center">
                                        2
                                      </th>
                                      <td className="text-center">
                                        16/08/2024
                                      </td>
                                      <td className="text-center">9.31</td>
                                      <td className="text-center">6.30</td>
                                      <td className="text-center">8 hrs</td>
                                      <td className="text-center">1</td>
                                      <td>-</td>
                                    </tr>
                                    <tr>
                                      <th scope="row" className="text-center">
                                        3
                                      </th>
                                      <td className="text-center">
                                        21/08/2024
                                      </td>
                                      <td className="text-center">9.34</td>
                                      <td className="text-center">6.30</td>
                                      <td className="text-center">8 hrs</td>
                                      <td className="text-center">1</td>
                                      <td>-</td>
                                    </tr>
                                    <tr>
                                      <th scope="row" className="text-center">
                                        4
                                      </th>
                                      <td className="text-center">
                                        22/08/2024
                                      </td>
                                      <td className="text-center">9.31</td>
                                      <td className="text-center">6.30</td>
                                      <td className="text-center">8 hrs</td>
                                      <td className="text-center">1</td>
                                      <td>-</td>
                                    </tr>
                                    <tr>
                                      <th scope="row" className="text-center">
                                        5
                                      </th>
                                      <td className="text-center">
                                        22/08/2024
                                      </td>
                                      <td className="text-center">9.31</td>
                                      <td className="text-center">6.30</td>
                                      <td className="text-center">8 hrs</td>
                                      <td className="text-center">1</td>
                                      <td>-</td>
                                    </tr>
                                    <tr>
                                      <th scope="row" className="text-center">
                                        6
                                      </th>
                                      <td className="text-center">
                                        22/08/2024
                                      </td>
                                      <td className="text-center">9.31</td>
                                      <td className="text-center">6.30</td>
                                      <td className="text-center">8 hrs</td>
                                      <td className="text-center">1</td>
                                      <td>-</td>
                                    </tr>
                                    <tr>
                                      <th scope="row" className="text-center">
                                        7
                                      </th>
                                      <td className="text-center">
                                        22/08/2024
                                      </td>
                                      <td className="text-center">9.31</td>
                                      <td className="text-center">6.30</td>
                                      <td className="text-center">8 hrs</td>
                                      <td className="text-center">1</td>
                                      <td>-</td>
                                    </tr>
                                    <tr>
                                      <th scope="row" className="text-center">
                                        8
                                      </th>
                                      <td className="text-center">
                                        22/08/2024
                                      </td>
                                      <td className="text-center">9.31</td>
                                      <td className="text-center">6.30</td>
                                      <td className="text-center">8 hrs</td>
                                      <td className="text-center">1</td>
                                      <td>-</td>
                                    </tr>
                                    <tr>
                                      <th scope="row" className="text-center">
                                        9
                                      </th>
                                      <td className="text-center">
                                        22/08/2024
                                      </td>
                                      <td className="text-center">9.31</td>
                                      <td className="text-center">6.30</td>
                                      <td className="text-center">8 hrs</td>
                                      <td className="text-center">1</td>
                                      <td>-</td>
                                    </tr>
                                    <tr>
                                      <th scope="row" className="text-center">
                                        10
                                      </th>
                                      <td className="text-center">
                                        22/08/2024
                                      </td>
                                      <td className="text-center">9.31</td>
                                      <td className="text-center">6.30</td>
                                      <td className="text-center">8 hrs</td>
                                      <td className="text-center">1</td>
                                      <td>-</td>
                                    </tr>
                                    <tr>
                                      <th scope="row" className="text-center">
                                        11
                                      </th>
                                      <td className="text-center">
                                        22/08/2024
                                      </td>
                                      <td className="text-center">9.31</td>
                                      <td className="text-center">6.30</td>
                                      <td className="text-center">8 hrs</td>
                                      <td className="text-center">1</td>
                                      <td>-</td>
                                    </tr>
                                  </tbody>
                                </Table>
                              </div>
                              {/* </div> */}
                            </div>
                          </Row>
                        </Container>
                        {formPopup ? (
                          <div id="punch-filter">
                            <div className="popup-form p-4">
                              <Form
                                onSubmit={e => {
                                  e.preventDefault()
                                }}
                              >
                                <Row className="align-items-end">
                                  <Row
                                    className="d-flex pe-0 me-0"
                                    style={{ width: "100%" }}
                                  >
                                    <div className="col-md-3 mt-2">
                                      <label htmlFor="">Month</label>
                                      <Select
                                        placeholder="Select Month"
                                        className="basic-multi-select"
                                        classNamePrefix=" select"
                                        // styles={colourStyles}
                                        options={month_option}
                                        closeMenuOnSelect={false}
                                      />
                                    </div>

                                    <div className="col-md-3 mt-2">
                                      <label htmlFor="">
                                        Save and Clear Filters
                                      </label>
                                      <div>
                                        <a
                                          className="btn  btn-primary mr-10"
                                          style={{
                                            fontSize: "11px",
                                            backgroundColor: "#93a6ff",
                                            borderColor: "#93a6ff",
                                            color: "black",
                                          }}
                                        >
                                          Save Filters
                                        </a>
                                        <a
                                          className="btn  btn-danger"
                                          style={{
                                            fontSize: "11px",
                                            backgroundColor: "#fed36d",
                                            borderColor: "#fed36d",
                                            color: "black",
                                          }}
                                        >
                                          Clear Filters
                                        </a>
                                      </div>
                                    </div>
                                    <div className="d-flex col-md-2 mb-1 align-items-end justify-content-end">
                                      <div className="mr-10">
                                        <button className="btn  btn-purple">
                                          <i className="fas fa-filter search-icon me-1 icon-center"></i>{" "}
                                          Filter
                                        </button>
                                      </div>
                                      <div className="">
                                        <a
                                          className="btn  btn-red"
                                          onClick={() => setFormPopup(false)}
                                        >
                                          <i className="dripicons-cross me-1 icon-center"></i>{" "}
                                          Close
                                        </a>
                                      </div>
                                    </div>
                                  </Row>
                                </Row>
                              </Form>
                              <i className="bi bi-triangle-fill pop-icon"></i>
                            </div>
                          </div>
                        ) : null}
                      </div>

                      {/* <h1>Step 4</h1> */}
                      {/* <div
                        style={{
                          display: currentStep === 4 ? "block" : "none",
                        }}
                      >
                        <div className="container">
                          <Card>
                            <CardBody>
                              <div className="d-flex justify-content-center align-items-center">
                                <div className="d-flex justify-content-center align-items-center flex-column gap-2">
                                  <h3>Confirm Details</h3>

                                  <div className="col-md-4">
                                    <img
                                      src={ConfirmDetails}
                                      className="img-fluid"
                                    ></img>
                                  </div>

                                  <div className="d-flex flex-column my-2 text-center">
                                    <button className=" btn btn-save btn-label ms-5 mb-2"
                                    style={{width :"55%"}}>
                      
                                      <i className="bi bi-check-circle-fill label-icon"></i>
                                      Finish
                                    </button>
                                    <span>
                                      Click here to finish the process
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </div>
                      </div> */}

                      {steps.map(step => (
                        <Step
                          key={step.id}
                          step={step}
                          stepCount={steps.length}
                          currentStep={currentStep}
                          onStepChange={stepChanged}
                        />
                      ))}
                    </div>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default PunchDetails
